import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=edbb25a2&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\public\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edbb25a2')) {
      api.createRecord('edbb25a2', component.options)
    } else {
      api.reload('edbb25a2', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=edbb25a2&", function () {
      api.rerender('edbb25a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Footer/Footer.vue"
export default component.exports